export default [
    {
        path: '/notas', component: () => import('./components/Page'), name: 'leilao.notas.page', children: [
            {path: '', component: () => import('./components/List'), name: 'leilao.notas'},
            {path: ':id', component: () => import('./components/Show'), name: 'leilao.notas.show'},
        ]
    }
]
